import "./index.css";
import "remixicon/fonts/remixicon.css";
import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App.jsx";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Register from "./components/Register/Register";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Fragment>
        <BrowserRouter>
            <Routes>
                <Route path='/register/*' element={<Register />}></Route>

                <Route path='/*' element={<App />} />
            </Routes>
        </BrowserRouter>
    </Fragment>
);
reportWebVitals();
